//import { faFileAlt } from "@elynx/free-regular-svg-icons";
import {
    faArchive,
    faBriefcase,
    faBell,
    faChartArea,
    faChartGantt,
    faColumns,
    faKeyboard,
    faList,
    faLocation,
    //faNewspaper,
    faPenToSquare,
    //faStickyNote,
    faTable,
    //faBarChart,
    faChartColumn
} from "@elynx/free-solid-svg-icons";
import { faFileSpreadsheet, faImage } from "@elynx/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dashboard, Send, TrackChanges } from "@mui/icons-material";
//import { DynamicForm } from "@mui/icons-material";
import LocalPlayIcon from "@mui/icons-material/LocalPlay";
import Enumerable from "linq";
import { lazy, type JSX } from "react";
//import React from "react";
import { UIViewEnum } from "../common/enums/UIViewEnum";
// import AdminLayout from "../layouts/admin-layout/AdminLayout";
import i18n from "../services/localization-service/i18n";

////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Views that are available offline must be included in the main bundle and loaded immediately
////////////////////////////////////////////////////////////////////////////////////////////////////////////
import AdministrationView from "../views/administration-view/AdministrationView";
import AuditReportingView from "../views/audit-reporting-view/AuditReportingView";
import ChangePasswordView from "../views/change-password-view/ChangePasswordView";
import DeviceDetailsView from "../views/device-details-view/DeviceDetailsView";
import LoginView from "../views/login-view/LoginView";
import ObjectFormView from "../views/object-form-view/ObjectFormView";
import ObjectManualEntryView from "../views/object-manual-entry-view/ObjectManualEntryView";
import SearchView from "../views/search-view/SearchView";
import SummaryListingContextProvider from "../components/summary-listing/SummaryListingContext";
import SummaryListingView from "../views/summary-listing-view/SummaryListingView";
import TankBatteryDetailsView from "../views/tank-battery-details-view/TankBatteryDetailsView";
import TankDetailsView from "../views/tank-details-view/TankDetailsView";
import WellDetailsView from "../views/well-details-view/WellDetailsView";
import AlarmSchemeAdministrationView from "../views/alarm-scheme-administration-view/AlarmSchemeAdministrationView";
import { isMobile, isTablet } from "react-device-detect";
import ManualEntryFormView from "../views/manual-entry-form-view/ManualEntryFormView";
// TODO: Why is this available offline?
import AlarmDashboardView from "../views/alarm-dashboard-view/AlarmDashboardView";
import AlarmNotificationAdminReportView from "../views/alarm-notification-admin-report-view/AlarmNotificationAdminReportView";
import GroupManualEntryView from "../views/group-manual-entry-view/GroupManualEntryView";
import AlarmScheduleAdministrationView from "../views/alarm-schedule-administration-view/AlarmScheduleAdministrationView";
import ObjectHistoryContextProvider from "../components/object-history/ObjectHistoryContext";
import UserPermissionsReportView from "../views/user-permissions-report-view/UserPermissionsReportView";
import RolePermissionsReportView from "../views/role-permissions-report-view/RolePermissionsReportView";
import UserListReportView from "../views/user-list-report-view/UserListReportView";
import AlarmSetpointReportView from "../views/alarm-setpoint-report-view/AlarmSetpointReportView";
import DisabledRecipientsReportView from "../views/disabled-recipients-report-view/DisabledRecipientsReportView";
import ScheduledReportsAdminView from "../views/scheduled-reports-administration-view/ScheduledReportsAdminView";
import PollingFrequencyAdminView from "../views/polling-frequency-admin-view/PollingFrequencyAdminView";
import DataFileImportView from "../views/data-file-import-view/DataFileImportView";
import UICustomizationPresetAdminView from "../views/ui-customization-preset-admin-view/UICustomizationPresetAdminView";
import UICustomizationPresetAdminContextProvider from "../views/ui-customization-preset-admin-view/UICustomizationPresetAdminViewState";


//import BadCommsReportView from "../views/bad-comms-report-view/BadCommsReportView";


////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Views that are not available offline may be split into individual bundles and lazy loaded when needed
////////////////////////////////////////////////////////////////////////////////////////////////////////////
const DynacardView = lazy(() => import("../views/dynacard-view/DynacardView"));
const GaugeSheet = lazy(() => import("../views/gauge-sheet-view/GaugeSheetView"));
const GaugeSheetExportView = lazy(() => import("../views/gauge-sheet-export-view/GaugeSheetExportView"));
const TankRelationshipsView = lazy(() => import("../views/tank-relationships-view/TankRelationshipsView"));
const GraphReportView = lazy(() => import("../views/graph-report-view/GraphReportView"));
const GroupMarketingReportView = lazy(() => import("../views/group-marketing-report-view/GroupMarketingReportView"));
const HistoricalDataView = lazy(() => import("../views/historical-data-view/HistoricalDataView"));
const ImageView = lazy(() => import("../views/image-view/ImageView"));
const MapView = lazy(() => import("../views/map-view/MapView"));
const ObjectDashboardView = lazy(() => import("../views/object-dashboard/ObjectDashboardView"));
const ObjectGraphContextProvider = lazy(() => import("../components/object-graph/ObjectGraphContext"));
const ObjectGraphView = lazy(() => import("../views/object-graph-view/ObjectGraphView"));
const PlaygroundView = lazy(() => import("../views/playground/PlaygroundView"));
const ProductionDashboardView = lazy(() => import("../views/production-dashboard-view/ProductionDashboardView"));
const PlungerAnalysisView = lazy(() => import("../views/plunger-analysis-view/PlungerAnalysisView"));
const DeviceMarketingReportView = lazy(() => import("../views/device-marketing-report-view/DeviceMarketingReportView"));
const ReportView = lazy(() => import("../views/report-view/ReportView"));
const SendReportView = lazy(() => import("../views/send-report-view/SendReportView"));
const TagDetailsView = lazy(() => import("../views/tag-details-view/TagDetailsView"));
const TagManualEntryView = lazy(() => import("../views/tag-manual-entry-view/TagManualEntryView"));
const ManageObjectsView = lazy(() => import("../views/manage-objects-view/ManageObjectsView"));
const CloneGroupMembershipView = lazy(() => import("../views/group-administration-view/clone-group-membership/CloneGroupMembership"));
const DynamicGroupConfigurationView = lazy(() => import("../views/group-administration-view/dynamic-group-configuration-view/DynamicGroupConfigurationView"));
const GroupContentsView = lazy(() => import("../views/group-administration-view/group-contents-view/GroupContentsView"));
const GroupManualEntryConfigurationView = lazy(() => import("../views/group-administration-view/group-manual-entry-configuration-view/GroupManualEntryConfigurationView"));
const GroupPropertiesView = lazy(() => import("../views/group-administration-view/group-properties-view/GroupProperties"));
const SystemBalanceConfigurationView = lazy(() => import("../views/group-administration-view/system-balance-configuration-view/SystemBalanceConfigurationView"));
const UserRoleAdministrationView = lazy(() => import("../views/user-role-administration-view/UserRoleAdministrationView"));
const UserRoleAdministrationContextProvider = lazy(() => import("../views/user-role-administration-view/UserRoleAdministrationViewState"));
const SetpointAdministrationView = lazy(() => import('../views/setpoint-administration-view/SetpointAdministrationView'));
const NotificationListAdministrationView = lazy(() => import('../views/notification-list-administration-view/NotificationListAdministrationView'));
const SecurityPermissionsView = lazy(() => import("../views/security-permissions-administration-view/SecurityPermissionsAdministrationView"));
const SecurityPermissionsContextProvider = lazy(() => import("../views/security-permissions-administration-view/SecurityPermissionsAdministrationViewState"));
const AttributeManagementView = lazy(() => import('../views/attribute-management-view/AttributeManagementView'));
const LookupListAdministrationView = lazy(() => import('../views/lookup-list-administration-view/LookupListAdminstrationView'));
const CommunicationsManagementView = lazy(() => import('../views/communications-management-view/CommunicationsManagementView'));
const RulesEngineAdministrationView = lazy(() => import("../views/rules-engine-administration-view/RulesEngineAdministrationView"));
const RulesEngineAdministrationContextProvider = lazy(() => import("../views/rules-engine-administration-view/RulesEngineAdministrationViewState"));
const MemoAutoTextAdminView = lazy(() => import('../views/memo-auto-text-admin-view/MemoAutoTextAdminView'));
const TankStyleAdminView = lazy(() => import('../views/tank-style-admin-view/TankStyleAdminView'));
const LiquidProductionAdminView = lazy(() => import('../views/liquid-production-admin-view/LiquidProductionAdminView'));
const ProductionForecastView = lazy(() => import("../views/production-forecast-view/ProductionForecastView"));
const TemplateAdminView = lazy(() => import("../views/template-admin-view/TemplateAdminView"));
const AccountingInvoiceView = lazy(() => import("../views/accounting-invoice-view/AccountingInvoiceView"));
const ManageObjectsViewContextProvider = lazy(() => import("../views/manage-objects-view/ManageObjectsViewState"));
const ConfigurationCleanupView = lazy(() => import("../views/configuration-cleanup-view/ConfigurationCleanupView"));

const isPhone = isMobile && !isTablet;

export type IRoute = {
    layout: string;
    path: string;
    fullPath?: string;
    exact?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component?: (props?: any) => JSX.Element;
    name: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    icon?: any;
    viewID?: UIViewEnum;
    groupingViewID?: UIViewEnum;
    allowMobile?: boolean;
    allowOffline?: boolean;
    category?: UIViewCategory;
    subCategory?: UIViewSubCategory,
    parentViewID?: UIViewEnum;

    excludeFromActivityLog?: boolean;

    order?: number;
    customizationDisabled?: boolean;
    isCategoryDefault?: boolean;
};

export enum UIViewCategory {
    Group = 'content.group',
    TankBattery = 'content.tankbattery',
    Device = 'content.device',
    Well = 'content.well',
    Tank = 'content.tank',
    Tag = 'content.tag',

    AdminGroup = 'admin.group',
    AdminView = 'admin.view'
}

export enum UIViewSubCategory {
    GroupVisualizations = 0,
    GroupDataEntry = 1,
    GroupReporting = 2,

    DeviceVisualizations = 10,
    DeviceDataEntry = 11,
    DeviceReporting = 12,

    WellVisualization = 20,
    WellDataEntry = 21,
    WellReporting = 22,

    TankBatteryVisualization = 30,
    TankBatteryDataEntry = 31,
    TankBatteryReporting = 32,

    TankVisualization = 40,
    TankDataEntry = 41,
    TankReporting = 42,

    TagVisualization = 50,
    TagDataEntry = 51,
    TagReporting = 52,

    Uncategorized = 9999
}


export const routes: IRoute[] = [
    //////////////////////////////////////////////////////////////////////
    //#region Layouts
    // {
    //     layout: "default",
    //     path: "admin",
    //     component: AdminLayout,
    //     name: i18n.t("views.adminLayout"),
    // },
    // {
    //     layout: "default",
    //     path: "content",
    //     // component: () =>
    //     //     <ContentLayoutContextProvider>
    //     //         <ContentLayout />
    //     //     </ContentLayoutContextProvider>,
    //     component: ContentLayout,
    //     name: i18n.t("views.contentLayout"),
    // },
    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Group Views
    {
        layout: "default",
        path: "summary-listing",
        fullPath: "/default/summary-listing",
        component: () =>
            <SummaryListingContextProvider>
                <SummaryListingView />
            </SummaryListingContextProvider>,
        name: i18n.t("views.summaryListing"),
        icon: () => <FontAwesomeIcon icon={faTable} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Group_SummaryListing,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupVisualizations,

        excludeFromActivityLog: true,
        order: 0,
        isCategoryDefault: true
    },
    {
        layout: "default",
        path: "devices",
        fullPath: "/default/summary-listing/devices",
        name: i18n.t("views.summaryListingDevices"),
        viewID: UIViewEnum.Group_SummaryListing_Devices,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Group,
        parentViewID: UIViewEnum.Group_SummaryListing
    },
    {
        layout: "default",
        path: "wells",
        fullPath: "/default/summary-listing/wells",
        name: i18n.t("views.summaryListingWells"),
        viewID: UIViewEnum.Group_SummaryListing_Wells,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Group,
        parentViewID: UIViewEnum.Group_SummaryListing
    },
    {
        layout: "default",
        path: "tank-batteries",
        fullPath: "/default/summary-listing/tank-batteries",
        name: i18n.t("views.summaryListingTankBatteries"),
        viewID: UIViewEnum.Group_SummaryListing_TankBatteries,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Group,
        parentViewID: UIViewEnum.Group_SummaryListing
    },
    {
        layout: "default",
        path: "alarmlynx",
        fullPath: "/default/summary-listing/alarmlynx",
        name: i18n.t("views.summaryListingAlarmLynx"),
        viewID: UIViewEnum.Group_SummaryListing_AlarmLynx,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Group,
        parentViewID: UIViewEnum.Group_SummaryListing
    },
    {
        layout: "default",
        path: "compressorlynx",
        fullPath: "/default/summary-listing/compressorlynx",
        name: i18n.t("views.summaryListingCompressorLynx"),
        viewID: UIViewEnum.Group_SummaryListing_CompressorLynx,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Group,
        parentViewID: UIViewEnum.Group_SummaryListing
    },
    {
        layout: "default",
        path: "production-dashboard",
        fullPath: "/default/production-dashboard",
        component: () =>
            <ObjectGraphContextProvider>
                <ObjectHistoryContextProvider>
                    <ProductionDashboardView />
                </ObjectHistoryContextProvider>
            </ObjectGraphContextProvider>,
        name: i18n.t("views.productionDashboard"),
        icon: () => <FontAwesomeIcon icon={faColumns} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Group_ProductionDashboard,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupVisualizations,
        order: 3
    },
    {
        layout: "default",
        path: "map",
        fullPath: "/default/map",
        component: () => <MapView />,
        name: i18n.t("views.map"),
        icon: () => <FontAwesomeIcon icon={faLocation} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Group_MapView,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupVisualizations,
        order: 4
    },
    {
        layout: "default",
        path: "group-image",
        fullPath: "/default/group-image",
        component: () => <ImageView />,
        name: i18n.t("views.imageView"),
        icon: () => <FontAwesomeIcon icon={faImage} fixedWidth={true} size='lg' />,
        viewID: UIViewEnum.Group_HMIView,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupVisualizations,
        order: 5
    },
    {
        layout: "default",
        path: "alarm-dashboard",
        fullPath: "/default/alarm-dashboard",
        icon: () => <FontAwesomeIcon icon={faBell} fixedWidth={true} size="lg" />,
        component: () => <AlarmDashboardView />,
        name: i18n.t("views.alarmDashboard"),
        viewID: UIViewEnum.Group_AlarmDashboard,
        allowMobile: true,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupVisualizations,
        order: 6
    },
    {
        layout: "default",
        path: "group-marketing-report",
        fullPath: "/default/group-marketing-report",
        component: () => <GroupMarketingReportView />,
        name: i18n.t('views.groupMarketingReport'),
        icon: () => <i className='sw sw-money-graph fa-lg half-right' style={{ marginLeft: "2px" }} />,
        viewID: UIViewEnum.Group_MarketingReport,
        allowOffline: false,
        allowMobile: false,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupReporting,
        order: 11
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        layout: "default",
        path: "group-manual-entry",
        fullPath: "/default/group-manual-entry",
        component: () => <GroupManualEntryView />,
        name: i18n.t("views.groupManualEntry"),
        icon: () => <FontAwesomeIcon icon={faKeyboard} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Group_ManualEntry,
        // TODO: What should these be?        
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupDataEntry,
        order: 7
    },
    ////////////////////////////////////////////////////////////////////////////
    {
        layout: "default",
        path: "graph-report",
        fullPath: "/default/graph-report",
        component: () => <GraphReportView />,
        name: i18n.t("views.graphReport"),
        icon: () => <FontAwesomeIcon icon={faChartGantt} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Group_GraphReport,
        allowOffline: false,
        allowMobile: false,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupReporting,
        order: 10,
    },
    {
        layout: "default",
        path: "group-graph",
        fullPath: "/default/group-graph",
        component: () =>
            <ObjectGraphContextProvider>
                <ObjectGraphView />
            </ObjectGraphContextProvider>,
        name: i18n.t("views.groupGraph"),
        icon: () => <FontAwesomeIcon icon={faChartArea} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Group_Graph,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupVisualizations,
        order: 1
    },
    {
        layout: "default",
        path: "report",
        fullPath: "/default/report",
        component: () => <ReportView />,
        name: i18n.t("views.reporting"),
        icon: () => <FontAwesomeIcon icon={faFileSpreadsheet} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Group_Reporting,
        allowOffline: false,
        allowMobile: false,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupReporting,
        order: 9
    },
    {
        layout: "default",
        path: "group-form",
        fullPath: "/default/group-form",
        component: () => <ObjectFormView />,
        name: i18n.t("views.customForms"),
        icon: () => <FontAwesomeIcon icon={faPenToSquare} fixedWidth={true} size='lg' />,
        viewID: UIViewEnum.Group_CustomForm,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupDataEntry,
        order: 8
    },
    {
        layout: "default",
        path: "tank-relationships",
        fullPath: "/default/tank-relationships",
        component: () => <TankRelationshipsView />,
        name: i18n.t("views.tankRelationships"),
        icon: () => <i className='sw sw-tanks2 fa-lg half-right' style={{ marginLeft: "2px" }} />,
        viewID: UIViewEnum.Group_TankRelationshipReport,
        allowOffline: false,
        allowMobile: false,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupReporting,
        order: 12
    },

    {
        layout: "default",
        path: "gaugesheet-export",
        fullPath: "/default/gaugesheet-export",
        component: () => <GaugeSheetExportView />,
        name: i18n.t("views.gaugeSheetExport"),
        icon: () => <i className='sw sw-tanks fa-lg half-right' style={{ marginLeft: "2px" }} />,
        viewID: UIViewEnum.Group_GaugeSheetExport,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupReporting,
        order: 13
    },
    {
        layout: "default",
        path: "send-report",
        fullPath: "/default/send-report",
        component: () => <SendReportView />,
        name: i18n.t("views.sendReport"),
        icon: () => <Send />,
        viewID: UIViewEnum.Group_SendReport,
        //viewID: UIViewEnum.Group_GaugeSheetExport,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupReporting,
        order: 14
    },
    {
        layout: "default",
        path: "group-dashboard",
        fullPath: "/default/group-dashboard",
        component: () => <ObjectDashboardView />,
        name: i18n.t("views.dashboard"),
        icon: () => <Dashboard />,
        viewID: UIViewEnum.Group_Dashboard,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Group,
        subCategory: UIViewSubCategory.GroupVisualizations,
        order: 2
    },

    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Device Views
    {
        layout: "default",
        path: "device-details",
        fullPath: "/default/device-details",
        component: () => <DeviceDetailsView />,
        name: i18n.t("views.deviceDetails"),
        icon: () => <FontAwesomeIcon icon={faList} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Device_Details,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Device,
        excludeFromActivityLog: true,
        subCategory: UIViewSubCategory.DeviceVisualizations,
        order: 0,
        customizationDisabled: true,
        isCategoryDefault: true
    },
    {
        layout: "default",
        path: "values",
        fullPath: "/default/device-details/values",
        name: i18n.t("views.deviceDetailsTagValues"),
        viewID: UIViewEnum.Device_Details_Values,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Device,
        parentViewID: UIViewEnum.Device_Details
    },
    {
        layout: "default",
        path: "properties",
        fullPath: "/default/device-details/properties",
        name: i18n.t("views.deviceDetailsProperties"),
        viewID: UIViewEnum.Device_Details_Properties,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        parentViewID: UIViewEnum.Device_Details
    },
    {
        layout: "default",
        path: "defaults",
        fullPath: "/default/device-details/defaults",
        name: i18n.t("views.deviceDetailsDefaults"),
        viewID: UIViewEnum.Device_Details_Defaults,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        parentViewID: UIViewEnum.Device_Details
    },
    {
        layout: "default",
        path: "attachments",
        fullPath: "/default/device-details/attachments",
        name: i18n.t("views.deviceDetailsAttachments"),
        viewID: UIViewEnum.Device_Details_Attachments,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        parentViewID: UIViewEnum.Device_Details
    },
    {
        layout: "default",
        path: "alarm-setpoints",
        fullPath: "/default/device-details/alarm-setpoints",
        name: i18n.t("views.deviceDetailsAlarmSetpoints"),
        viewID: UIViewEnum.Device_Details_AlarmSetpoints,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        parentViewID: UIViewEnum.Device_Details
    },
    {
        layout: "default",
        path: "history",
        fullPath: "/default/device-details/history",
        name: i18n.t("views.deviceDetailsHistory"),
        viewID: UIViewEnum.Device_Details_History,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Device,
        parentViewID: UIViewEnum.Device_Details
    },
    {
        layout: "default",
        path: "run-tickets",
        fullPath: "/default/device-details/run-tickets",
        name: i18n.t("views.deviceDetailsRunTickets"),
        viewID: UIViewEnum.Device_Details_RunTickets,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Device,
        parentViewID: UIViewEnum.Device_Details
    },
    {
        layout: "default",
        path: "relationships",
        fullPath: "/default/device-details/relationships",
        name: i18n.t("views.deviceDetailsRelationships"),
        viewID: UIViewEnum.Device_Details_Relationships,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        parentViewID: UIViewEnum.Device_Details
    },
    {
        layout: "default",
        path: "external-content",
        fullPath: "/default/device-details/external-content",
        name: i18n.t("views.deviceDetailsUrlViewer"),
        viewID: UIViewEnum.Device_ExternalContent,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        parentViewID: UIViewEnum.Device_Details
    },
    {
        layout: "default",
        path: "plunger-analysis",
        fullPath: "/default/plunger-analysis",
        component: () => <ObjectGraphContextProvider>
            <PlungerAnalysisView />
        </ObjectGraphContextProvider>,
        name: i18n.t("views.plungerAnalysis"),
        icon: () => <FontAwesomeIcon icon={faChartColumn} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Device_PlungerAnalysis,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        subCategory: UIViewSubCategory.DeviceVisualizations,
        order: 11
    },
    {
        layout: "default",
        path: "object-manual-entry",
        fullPath: "/default/object-manual-entry",
        component: () => isPhone ? <ManualEntryFormView /> : <ObjectManualEntryView />,
        name: i18n.t("views.manualEntry"),
        icon: () => <FontAwesomeIcon icon={faKeyboard} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Device_ManualEntry,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Device,
        subCategory: UIViewSubCategory.DeviceDataEntry,
        order: 3
    },
    {
        layout: "default",
        path: "device-graph",
        fullPath: "/default/device-graph",
        component: () =>
            <ObjectGraphContextProvider>
                <ObjectGraphView />
            </ObjectGraphContextProvider>,
        name: i18n.t("views.deviceGraph"),
        icon: () => <FontAwesomeIcon icon={faChartArea} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Device_Graph,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        subCategory: UIViewSubCategory.DeviceVisualizations,
        order: 1
    },
    {
        layout: "default",
        path: "dynacards",
        fullPath: "/default/dynacards",
        component: () =>
            // <ObjectGraphContextProvider>
            <DynacardView />,
        // </ObjectGraphContextProvider>,                
        name: i18n.t("views.dynacards"),
        icon: () => <i className='sw sw-oil-pumpjack fa-lg' style={{ marginLeft: "2px" }} />,
        viewID: UIViewEnum.Device_Dynacard,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        subCategory: UIViewSubCategory.DeviceVisualizations,
        order: 7
    },
    {
        layout: "default",
        path: "dashboard",
        fullPath: "/default/dashboard",
        component: () => <ObjectDashboardView />,
        name: i18n.t("views.dashboard"),
        icon: () => <Dashboard />,
        viewID: UIViewEnum.Device_Dashboard,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        subCategory: UIViewSubCategory.DeviceVisualizations,
        order: 6
    },
    {
        layout: "default",
        path: "device-form",
        fullPath: "/default/device-form",
        component: () => <ObjectFormView />,
        name: i18n.t("views.customForms"),
        icon: () => <FontAwesomeIcon icon={faPenToSquare} fixedWidth={true} size='lg' />,
        viewID: UIViewEnum.Device_CustomForm,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Device,
        subCategory: UIViewSubCategory.DeviceDataEntry,
        order: 4
    },
    {
        layout: "default",
        path: "gauge-sheet",
        fullPath: "/default/gauge-sheet",
        component: () => <GaugeSheet />,
        name: i18n.t("views.gaugesheet"),
        icon: () => <i className='sw sw-tank fa-lg half-right' style={{ marginLeft: "2px" }} />,
        viewID: UIViewEnum.Device_GaugeSheet,
        allowOffline: false,
        allowMobile: false,
        category: UIViewCategory.Device,
        subCategory: UIViewSubCategory.DeviceDataEntry,
        order: 2
    },
    {
        layout: "default",
        path: "device-marketing-report",
        fullPath: "/default/device-marketing-report",
        component: () => <DeviceMarketingReportView />,
        name: i18n.t("views.deviceMarketingReport"),
        icon: () => <i className='sw sw-money-graph fa-lg half-right' style={{ marginLeft: "2px" }} />,
        viewID: UIViewEnum.Device_MarketingReport,
        allowOffline: false,
        allowMobile: false,
        category: UIViewCategory.Device,
        subCategory: UIViewSubCategory.DeviceReporting,
        order: 8
    },
    {
        layout: "default",
        path: "historical-data",
        fullPath: "/default/historical-data",
        component: () => <HistoricalDataView />,
        name: i18n.t("views.historicalData"),
        icon: () => <FontAwesomeIcon icon={faArchive} fixedWidth={true} size='lg' />,
        viewID: UIViewEnum.Device_HistoricalData,
        allowOffline: false,
        allowMobile: false,
        category: UIViewCategory.Device,
        subCategory: UIViewSubCategory.DeviceVisualizations,
        order: 9
    },
    {
        layout: "default",
        path: "device-image",
        fullPath: "/default/device-image",
        component: () => <ImageView />,
        name: i18n.t("views.imageView"),
        icon: () => <FontAwesomeIcon icon={faImage} fixedWidth={true} size='lg' />,
        viewID: UIViewEnum.Device_HMIView,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        subCategory: UIViewSubCategory.DeviceVisualizations,
        order: 5
    },
    {
        layout: "default",
        path: "production-forecast",
        fullPath: "/default/production-forecast",
        component: () => <ObjectGraphContextProvider>
            <ProductionForecastView />
        </ObjectGraphContextProvider>,
        name: i18n.t("views.productionForecast"),
        icon: () => <i className='sw sw-decline-graph fa-lg half-right' style={{ marginLeft: "2px" }} />,
        viewID: UIViewEnum.Device_ProductionForecasting,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Device,
        subCategory: UIViewSubCategory.DeviceVisualizations,
        order: 10
    },

    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Well Views
    {
        layout: "default",
        path: "well-details",
        fullPath: "/default/well-details",
        component: () => <WellDetailsView />,
        name: i18n.t("views.wellDetails"),
        icon: () => <FontAwesomeIcon icon={faList} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Well_Details,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Well,
        subCategory: UIViewSubCategory.WellVisualization,
        excludeFromActivityLog: true,
        order: 0,
        customizationDisabled: true,
        isCategoryDefault: true
    },
    {
        layout: "default",
        path: "values",
        fullPath: "/default/well-details/values",
        name: i18n.t("views.wellDetailsTagValues"),
        viewID: UIViewEnum.Well_Details_Values,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Well,
        parentViewID: UIViewEnum.Well_Details
    },
    {
        layout: "default",
        path: "properties",
        fullPath: "/default/well-details/properties",
        name: i18n.t("views.wellDetailsProperties"),
        viewID: UIViewEnum.Well_Details_Properties,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Well,
        parentViewID: UIViewEnum.Well_Details
    },
    {
        layout: "default",
        path: "alarm-setpoints",
        fullPath: "/default/well-details/alarm-setpoints",
        name: i18n.t("views.wellDetailsAlarmSetpoints"),
        viewID: UIViewEnum.Well_Details_AlarmSetpoints,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Well,
        parentViewID: UIViewEnum.Well_Details
    },
    {
        layout: "default",
        path: "attachments",
        fullPath: "/default/well-details/attachments",
        name: i18n.t("views.wellDetailsAttachments"),
        viewID: UIViewEnum.Well_Details_Attachments,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Well,
        parentViewID: UIViewEnum.Well_Details
    },
    {
        layout: "default",
        path: "history",
        fullPath: "/default/well-details/history",
        name: i18n.t("views.wellDetailsHistory"),
        viewID: UIViewEnum.Well_Details_History,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Well,
        parentViewID: UIViewEnum.Well_Details
    },
    {
        layout: "default",
        path: "relationships",
        fullPath: "/default/well-details/relationships",
        name: i18n.t("views.wellDetailsRelationships"),
        viewID: UIViewEnum.Well_Details_Relationships,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Well,
        parentViewID: UIViewEnum.Well_Details
    },
    {
        layout: "default",
        path: "well-details/external-content",
        fullPath: "/default/well-details/external-content",
        component: () => <WellDetailsView />,
        name: i18n.t("views.wellDetailsUrlViewer"),
        viewID: UIViewEnum.Well_ExternalContent,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Well,
        parentViewID: UIViewEnum.Well_Details
    },
    {
        layout: "default",
        path: "well-graph",
        fullPath: "/default/well-graph",
        component: () =>
            <ObjectGraphContextProvider>
                <ObjectGraphView />
            </ObjectGraphContextProvider>,
        name: i18n.t("views.wellGraph"),
        icon: () => <FontAwesomeIcon icon={faChartArea} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Well_Graph,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Well,
        subCategory: UIViewSubCategory.WellVisualization,
        order: 1
    },
    {
        layout: "default",
        path: "well-form",
        fullPath: "/default/well-form",
        component: () => <ObjectFormView />,
        name: i18n.t("views.customForms"),
        icon: () => <FontAwesomeIcon icon={faPenToSquare} fixedWidth={true} size='lg' />,
        viewID: UIViewEnum.Well_CustomForm,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Well,
        subCategory: UIViewSubCategory.WellDataEntry,
        order: 2
    },
    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Tank Battery Details
    {
        layout: "default",
        path: "tank-battery-details",
        fullPath: "/default/tank-battery-details",
        component: () => <TankBatteryDetailsView />,
        name: i18n.t("views.tankBatteryDetails"),
        icon: () => <FontAwesomeIcon icon={faList} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.TankBattery_Details,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.TankBattery,
        subCategory: UIViewSubCategory.TankBatteryVisualization,
        excludeFromActivityLog: true,
        order: 0,
        customizationDisabled: true,
        isCategoryDefault: true
    },
    {
        layout: "default",
        path: "values",
        fullPath: "/default/tank-battery-details/values",
        name: i18n.t("views.tankBatteryDetailsTagValues"),
        viewID: UIViewEnum.TankBattery_Details_Values,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.TankBattery,
        parentViewID: UIViewEnum.TankBattery_Details
    },
    {
        layout: "default",
        path: "properties",
        fullPath: "/default/tank-battery-details/properties",
        name: i18n.t("views.tankBatteryDetailsProperties"),
        viewID: UIViewEnum.TankBattery_Details_Properties,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.TankBattery,
        parentViewID: UIViewEnum.TankBattery_Details
    },
    {
        layout: "default",
        path: "alarm-setpoints",
        fullPath: "/default/tank-battery-details/alarm-setpoints",
        name: i18n.t("views.tankBatteryDetailsAlarmSetpoints"),
        viewID: UIViewEnum.TankBattery_Details_AlarmSetpoints,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.TankBattery,
        parentViewID: UIViewEnum.TankBattery_Details
    },
    {
        layout: "default",
        path: "attachments",
        fullPath: "/default/tank-battery-details/attachments",
        name: i18n.t("views.tankBatteryDetailsAttachments"),
        viewID: UIViewEnum.TankBattery_Details_Attachments,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.TankBattery,
        parentViewID: UIViewEnum.TankBattery_Details
    },
    {
        layout: "default",
        path: "history",
        fullPath: "/default/tank-battery-details/history",
        name: i18n.t("views.tankBatteryDetailsHistory"),
        viewID: UIViewEnum.TankBattery_Details_History,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.TankBattery,
        parentViewID: UIViewEnum.TankBattery_Details
    },
    {
        layout: "default",
        path: "run-tickets",
        fullPath: "/default/tank-battery-details/run-tickets",
        name: i18n.t("views.tankBatteryDetailsRunTickets"),
        viewID: UIViewEnum.TankBattery_Details_RunTickets,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.TankBattery,
        parentViewID: UIViewEnum.TankBattery_Details
    },
    {
        layout: "default",
        path: "relationships",
        fullPath: "/default/tank-battery-details/relationships",
        name: i18n.t("views.tankBatteryDetailsRelationships"),
        viewID: UIViewEnum.TankBattery_Details_Relationships,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.TankBattery,
        parentViewID: UIViewEnum.TankBattery_Details
    },
    {
        layout: "default",
        path: "external-content",
        fullPath: "/default/tank-battery-details/external-content",
        name: i18n.t("views.tankBatteryDetailsUrlViewer"),
        viewID: UIViewEnum.TankBattery_ExternalContent,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.TankBattery,
        parentViewID: UIViewEnum.TankBattery_Details
    },
    {
        layout: "default",
        path: "tank-battery-form",
        fullPath: "/default/tank-battery-form",
        component: () => <ObjectFormView />,
        name: i18n.t("views.customForms"),
        icon: () => <FontAwesomeIcon icon={faPenToSquare} fixedWidth={true} size='lg' />,
        viewID: UIViewEnum.TankBattery_CustomForm,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.TankBattery,
        subCategory: UIViewSubCategory.TankBatteryDataEntry,
        order: 1
    },

    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Tank Details
    {
        layout: "default",
        path: "tank-details",
        fullPath: "/default/tank-details",
        component: () => <TankDetailsView />,
        name: i18n.t("views.tankDetails"),
        icon: () => <FontAwesomeIcon icon={faList} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Tank_Details,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Tank,
        subCategory: UIViewSubCategory.TankVisualization,
        excludeFromActivityLog: true,
        order: 0,
        customizationDisabled: true,
        isCategoryDefault: true
    },
    {
        layout: "default",
        path: "values",
        fullPath: "/default/tank-details/values",
        name: i18n.t("views.tankDetailsTagValues"),
        viewID: UIViewEnum.Tank_Details_Values,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Tank,
        parentViewID: UIViewEnum.Tank_Details
    },
    {
        layout: "default",
        path: "properties",
        fullPath: "/default/tank-details/properties",
        name: i18n.t("views.tankDetailsProperties"),
        viewID: UIViewEnum.Tank_Details_Properties,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Tank,
        parentViewID: UIViewEnum.Tank_Details
    },
    {
        layout: "default",
        path: "alarm-setpoints",
        fullPath: "/default/tank-details/alarm-setpoints",
        name: i18n.t("views.tankDetailsAlarmSetpoints"),
        viewID: UIViewEnum.Tank_Details_AlarmSetpoints,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Tank,
        parentViewID: UIViewEnum.Tank_Details
    },
    {
        layout: "default",
        path: "attachments",
        fullPath: "/default/tank-details/attachments",
        name: i18n.t("views.tankDetailsAttachments"),
        viewID: UIViewEnum.Tank_Details_Attachments,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Tank,
        parentViewID: UIViewEnum.Tank_Details
    },
    {
        layout: "default",
        path: "history",
        fullPath: "/default/tank-details/history",
        name: i18n.t("views.tankDetailsHistory"),
        viewID: UIViewEnum.Tank_Details_History,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Tank,
        parentViewID: UIViewEnum.Tank_Details
    },
    {
        layout: "default",
        path: "run-tickets",
        fullPath: "/default/tank-details/run-tickets",
        name: i18n.t("views.tankDetailsRunTickets"),
        viewID: UIViewEnum.Tank_Details_RunTickets,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Tank,
        parentViewID: UIViewEnum.Tank_Details
    },
    {
        layout: "default",
        path: "external-content",
        fullPath: "/default/tank-details/external-content",
        name: i18n.t("views.tankDetailsUrlViewer"),
        viewID: UIViewEnum.Tank_ExternalContent,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Tank,
        parentViewID: UIViewEnum.Tank_Details
    },
    {
        layout: "default",
        path: "relationships",
        fullPath: "/default/tank-details/relationships",
        name: i18n.t("views.tankDetailsRelationships"),
        viewID: UIViewEnum.Tank_Details_Relationships,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Tank,
        parentViewID: UIViewEnum.Tank_Details
    }, {
        layout: "default",
        path: "tank-form",
        fullPath: "/default/tank-form",
        component: () => <ObjectFormView />,
        name: i18n.t("views.customForms"),
        icon: () => <FontAwesomeIcon icon={faPenToSquare} fixedWidth={true} size='lg' />,
        viewID: UIViewEnum.Tank_CustomForm,
        allowOffline: true,
        allowMobile: true,
        category: UIViewCategory.Tank,
        subCategory: UIViewSubCategory.TankDataEntry,
        order: 1
    },

    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Tag Views
    {
        layout: "default",
        path: "tag-details",
        fullPath: "/default/tag-details",
        component: () => <TagDetailsView />,
        name: i18n.t("views.tagDetails"),
        icon: () => <FontAwesomeIcon icon={faList} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Tag_Details,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Tag,
        subCategory: UIViewSubCategory.TagVisualization,
        excludeFromActivityLog: true,
        order: 0,
        customizationDisabled: true,
        isCategoryDefault: true
    },
    {
        layout: "default",
        path: "values",
        fullPath: "/default/tag-details/values",
        name: i18n.t("views.tagDetailsValues"),
        viewID: UIViewEnum.Tag_Details_Values,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Tag,
        parentViewID: UIViewEnum.Tag_Details
    },
    {
        layout: "default",
        path: "properties",
        fullPath: "/default/tag-details/properties",
        name: i18n.t("views.tagDetailsProperties"),
        viewID: UIViewEnum.Tag_Details_Properties,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Tag,
        parentViewID: UIViewEnum.Tag_Details
    },
    {
        layout: "default",
        path: "alarm-setpoints",
        fullPath: "/default/tag-details/alarm-setpoints",
        name: i18n.t("views.tagDetailsAlarmSetpoints"),
        viewID: UIViewEnum.Tag_Details_AlarmSetpoints,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Tag,
        parentViewID: UIViewEnum.Tag_Details
    },
    {
        layout: "default",
        path: "history",
        fullPath: "/default/tag-details/history",
        name: i18n.t("views.tagDetailsHistory"),
        viewID: UIViewEnum.Tag_Details_History,
        allowOffline: false,
        allowMobile: false,
        category: UIViewCategory.Tag,
        parentViewID: UIViewEnum.Tag_Details
    },
    {
        layout: "default",
        path: "runtime-statistics",
        fullPath: "/default/tag-details/runtime-statistics",
        name: i18n.t("views.tagDetailsRuntimeStatistics"),
        viewID: UIViewEnum.Tag_Details_RuntimeStatistics,
        allowOffline: false,
        allowMobile: false,
        category: UIViewCategory.Tag,
        parentViewID: UIViewEnum.Tag_Details
    },
    {
        layout: "default",
        path: "tag-manual-entry",
        fullPath: "/default/tag-manual-entry",
        component: () => <TagManualEntryView />,
        name: i18n.t("views.manualEntry"),
        icon: () => <FontAwesomeIcon icon={faKeyboard} fixedWidth={true} size="lg" />,
        viewID: UIViewEnum.Tag_ManualEntry,
        allowOffline: false,
        allowMobile: true,
        category: UIViewCategory.Tag,
        subCategory: UIViewSubCategory.TagDataEntry,
        excludeFromActivityLog: true,
        order: 1
    },
    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Misc Views
    {
        layout: "full",
        path: "login",
        fullPath: "/login",
        component: LoginView,
        name: i18n.t("views.login"),
        exact: true,
        viewID: UIViewEnum.Login,
        excludeFromActivityLog: true
    },
    {
        layout: "full",
        path: "change-password",
        fullPath: "/change-password",
        component: ChangePasswordView,
        name: i18n.t("views.changePassword"),
        viewID: UIViewEnum.ChangePassword,
        excludeFromActivityLog: true
    },
    {
        layout: "default",
        path: "search",
        fullPath: "/default/search",
        component: SearchView,
        name: i18n.t("views.searchResults"),
        //icon: LocalPlayIcon,
        //category: UIViewCategory.Group,
        viewID: UIViewEnum.SearchResults
    },
    {
        layout: "default",
        path: "playground",
        fullPath: "/default/playground",
        component: () => <PlaygroundView />,
        name: i18n.t("views.playground"),
        icon: LocalPlayIcon,
        //category: UIViewCategory.Group,
        viewID: UIViewEnum.Playground,
        allowMobile: true
    },
    //#endregion


    //admininstration
    {
        layout: "default",
        path: "administration",
        fullPath: "/default/administration",
        component: AdministrationView,
        name: i18n.t("views.administration"),
        viewID: UIViewEnum.Administration,
        category: UIViewCategory.AdminGroup
    },

    // Users and Security
    {
        layout: "default",
        path: "user-role-administration",
        fullPath: "/default/user-role-administration",
        component: () =>
            <UserRoleAdministrationContextProvider>
                <UserRoleAdministrationView />
            </UserRoleAdministrationContextProvider>,
        name: i18n.t("views.userRoleAdministration"),
        viewID: UIViewEnum.UsersAndSecurity_UserRoleAdmin,
        parentViewID: UIViewEnum.UsersAndSecurity_UserRoleAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: false,
        groupingViewID: UIViewEnum.UsersAndSecurity,
    },
    {
        layout: "default",
        path: "security-permissions",
        fullPath: "/default/security-permissions",
        component: () =>
            <SecurityPermissionsContextProvider>
                <SecurityPermissionsView />
            </SecurityPermissionsContextProvider>,
        name: i18n.t("views.securityPermissions"),
        viewID: UIViewEnum.UsersAndSecurity_SecurityPermissions,
        parentViewID: UIViewEnum.UsersAndSecurity_SecurityPermissions,
        category: UIViewCategory.AdminView,
        allowMobile: false,
        groupingViewID: UIViewEnum.UsersAndSecurity,
    },

    {
        layout: "default",
        path: "setpoint-administration",
        fullPath: "/default/setpoint-administration",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <SetpointAdministrationView />,
        name: i18n.t("views.setpointAdministration"),
        viewID: UIViewEnum.AlarmsAndNotification_SetPointAdmin,
        parentViewID: UIViewEnum.SetPointAdmin_v2,
        category: UIViewCategory.AdminView,
        allowMobile: true,

        groupingViewID: UIViewEnum.AlarmsAndNotification_SetPointAdmin,
    },
    {
        layout: "default",
        path: "notification-list-administration",
        fullPath: "/default/notification-list-administration",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <NotificationListAdministrationView />,
        name: i18n.t("views.notificationListAdministration"),
        viewID: UIViewEnum.AlarmsAndNotification_NotificationListAdmin,
        //viewID: UIViewEnum.AlarmsAndNotification_SetPointAdmin,
        parentViewID: UIViewEnum.NotificationListAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: true,

        groupingViewID: UIViewEnum.AlarmsAndNotification_SetPointAdmin,
    },
    {
        layout: "default",
        path: "alarm-scheme-administration",
        fullPath: "/default/alarm-scheme-administration",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <AlarmSchemeAdministrationView />,
        name: i18n.t("views.alarmSchemeAdministration"),
        viewID: UIViewEnum.AlarmsAndNotification_AlarmSchemeAdmin,
        parentViewID: UIViewEnum.AlarmSchemeAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: true,
        groupingViewID: UIViewEnum.AlarmsAndNotification_SetPointAdmin,
    },

    {
        layout: "default",
        path: "alarm-schedule-administration",
        fullPath: "/default/alarm-schedule-administration",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <AlarmScheduleAdministrationView />,
        name: i18n.t("views.alarmScheduleAdministration"),
        viewID: UIViewEnum.AlarmsAndNotification_AlarmScheduleAdmin,
        parentViewID: UIViewEnum.ScheduleAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: true,
        groupingViewID: UIViewEnum.AlarmsAndNotification_SetPointAdmin,
    },


    // {
    //     layout: "default",
    //     path: "alarm-dashboard",
    //     fullPath: "/default/alarm-dashboard",
    //     icon: () => <FontAwesomeIcon icon={faBell} size="lg"  />,
    //     component: () => <AlarmDashboardView />,
    //     name: i18n.t("views.alarmDashboard"),
    //     viewID: UIViewEnum.AlarmNotificationDashboard,
    //     //viewID: UIViewEnum.AlarmsAndNotification_AlarmDashboard,
    //     //parentViewID: UIViewEnum.AlarmNotificationDashboard,
    //     category: UIViewCategory.Group,
    //     allowMobile: true,
    //     //groupingViewID: UIViewEnum.AlarmsAndNotification_SetPointAdmin,
    // },
    {
        layout: "default",
        path: "setpoint-report",
        fullPath: "/default/setpoint-report",
        //icon: () => <FontAwesomeIcon icon={faBriefcase} size="lg"  />,
        component: AlarmSetpointReportView,
        name: i18n.t("views.setpointReport"),
        viewID: UIViewEnum.Setpoint_Report,
        parentViewID: UIViewEnum.AlarmSetPointReport,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.AlarmsAndNotification_SetPointAdmin,
    },
    {
        layout: "default",
        path: "alarm-notification-report",
        fullPath: "/default/alarm-notification-report",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <AlarmNotificationAdminReportView />,
        name: i18n.t("views.alarmNotificationReport"),
        viewID: UIViewEnum.AlarmsAndNotification_AlarmNotificationReport,
        parentViewID: UIViewEnum.AlarmNotificationReport,
        category: UIViewCategory.AdminView,
        allowMobile: true,
        groupingViewID: UIViewEnum.AlarmsAndNotification_SetPointAdmin,
    },


    {
        layout: "default",
        path: "rules-engine-administration",
        fullPath: "/default/rules-engine-administration",
        component: () =>
            <RulesEngineAdministrationContextProvider>
                <RulesEngineAdministrationView />
            </RulesEngineAdministrationContextProvider>,
        name: i18n.t("views.rulesEngineAdministration"),
        viewID: UIViewEnum.AlarmsAndNotification_RulesEngineAdmin,
        parentViewID: UIViewEnum.RulesEngineAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: false,
        groupingViewID: UIViewEnum.AlarmsAndNotification_SetPointAdmin
    },


    // 2024-02-12 Per Josh W. not required at this time
    // {
    //     layout: "default",
    //     path: "bad-comms-report",
    //     fullPath: "/default/bad-comms-report",
    //     //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
    //     component: () => <BadCommsReportView />,
    //     name: i18n.t("views.badCommsReport"),
    //     viewID: UIViewEnum.AlarmsAndNotification_BadCommsReport,
    //     parentViewID: UIViewEnum.BadCommsReport,
    //     category: UIViewCategory.AdminView,
    //     allowMobile: true,
    //     groupingViewID: UIViewEnum.AlarmsAndNotification_SetPointAdmin,
    // },

    {
        layout: "default",
        path: "manage-objects",
        fullPath: "/default/manage-objects",
        icon: () => <FontAwesomeIcon icon={faBriefcase} size="lg" />,
        component: () =>
            <ManageObjectsViewContextProvider>
                <ManageObjectsView />
            </ManageObjectsViewContextProvider>,
        name: i18n.t("views.manageObjects"),
        viewID: UIViewEnum.ObjectAdmin_Manage_Objects,
        parentViewID: UIViewEnum.ObjectAdmin,
        category: UIViewCategory.AdminView,
        allowOffline: false,
        allowMobile: true
    },
    {
        layout: "default",
        path: "comm-management",
        fullPath: "/default/comm-management",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <CommunicationsManagementView />,
        name: i18n.t("views.communicationsManagement"),
        viewID: UIViewEnum.CommManagement,
        parentViewID: UIViewEnum.CommManagement,
        category: UIViewCategory.AdminView,
        allowOffline: false,
        allowMobile: true,
        groupingViewID: UIViewEnum.ObjectAdmin
    },
    {
        layout: "default",
        path: "polling-frequency-admin",
        fullPath: "/default/polling-frequency-admin",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <PollingFrequencyAdminView />,
        name: i18n.t("views.pollingFrequencyAdmin"),
        viewID: UIViewEnum.PollingFrequencyAdmin,
        parentViewID: UIViewEnum.PollingFrequencyAdmin,
        category: UIViewCategory.AdminView,
        allowOffline: false,
        allowMobile: true,
        groupingViewID: UIViewEnum.ObjectAdmin
    },
    {
        layout: "default",
        path: "tank-styles",
        fullPath: "/default/tank-styles",
        component: () => <TankStyleAdminView />,
        name: i18n.t("views.tankStyleAdmin"),
        viewID: UIViewEnum.TankStyleAdmin,
        parentViewID: UIViewEnum.TankStyleAdmin,
        category: UIViewCategory.AdminView,
        allowOffline: false,
        allowMobile: true,
        groupingViewID: UIViewEnum.ObjectAdmin
    },
    {
        layout: "default",
        path: "liquid-production-admin",
        fullPath: "/default/liquid-production-admin",
        component: () => <LiquidProductionAdminView />,
        name: i18n.t("views.liquidProductionAdmin"),
        viewID: UIViewEnum.TankPadAdmin,
        parentViewID: UIViewEnum.TankPadAdmin,
        category: UIViewCategory.AdminView,
        allowOffline: false,
        allowMobile: true,
        groupingViewID: UIViewEnum.ObjectAdmin
    },
    {
        layout: "default",
        path: "template-administration",
        fullPath: "/default/template-administration",
        component: () => <TemplateAdminView />,
        name: i18n.t("views.templateAdministration"),
        viewID: UIViewEnum.TemplateAdmin,
        parentViewID: UIViewEnum.TemplateAdmin,
        category: UIViewCategory.AdminView,
        allowOffline: false,
        allowMobile: false,
        groupingViewID: UIViewEnum.ObjectAdmin
    },

    // Group Administration
    {
        layout: "default",
        path: "group-properties",
        fullPath: "/default/group-properties",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <GroupPropertiesView />,
        name: i18n.t("views.groupProperties"),
        viewID: UIViewEnum.Group_Properties,
        parentViewID: UIViewEnum.GroupAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: false,
    },
    {
        layout: "default",
        path: "group-contents",
        fullPath: "/default/group-contents",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <GroupContentsView />,
        name: i18n.t("views.groupContents"),
        viewID: UIViewEnum.Group_Contents,
        parentViewID: UIViewEnum.GroupAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: false,
    },
    {
        layout: "default",
        path: "group-manual-entry-configuration",
        fullPath: "/default/group-manual-entry-configuration",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <GroupManualEntryConfigurationView />,
        name: i18n.t("views.groupManualEntryConfiguration"),
        viewID: UIViewEnum.Group_ManualEntry_Configuration,
        parentViewID: UIViewEnum.GroupAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: false
    },
    {
        layout: "default",
        path: "group-system-balance-configuration",
        fullPath: "/default/group-system-balance-configuration",
        component: () => <SystemBalanceConfigurationView />,
        name: i18n.t("views.groupSystemBalanceConfiguration"),
        viewID: UIViewEnum.Group_System_Balance_Configuration,
        parentViewID: UIViewEnum.GroupAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: false
    },
    {
        layout: "default",
        path: "dynamic-group-configuration",
        fullPath: "/default/dynamic-group-configuration",
        component: () => <DynamicGroupConfigurationView />,
        name: i18n.t("views.dynamicGroupConfiguration"),
        viewID: UIViewEnum.Group_Dynamic_Group_Configuration,
        parentViewID: UIViewEnum.GroupAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: false
    },
    {
        layout: "default",
        path: "group-clone-membership",
        fullPath: "/default/group-clone-membership",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <CloneGroupMembershipView />,
        name: i18n.t("views.cloneGroupMembership"),
        viewID: UIViewEnum.Group_Clone_Membership,
        parentViewID: UIViewEnum.GroupAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: false
    },
    {
        layout: "default",
        path: "audit-reporting",
        fullPath: "/default/audit-reporting",
        //icon: () => <FontAwesomeIcon icon={faBriefcase} size="lg"  />,
        icon: () => <TrackChanges />,
        component: AuditReportingView,
        name: i18n.t("views.auditReporting"),
        viewID: UIViewEnum.AuditReporting_Report,
        parentViewID: UIViewEnum.AuditReporting,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.AdminMiscellaneous,
    },
    {
        layout: "default",
        path: "attribute-management",
        fullPath: "/default/attribute-management",
        //icon: () => <TrackChanges />,
        component: () => <AttributeManagementView />,
        name: i18n.t("views.attributeManagement"),
        viewID: UIViewEnum.AttributeManagement_Admin,
        parentViewID: UIViewEnum.AttributeManagement,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.AdminMiscellaneous,
        allowMobile: true
    },
    {
        layout: "default",
        path: "lookup-list-administration",
        fullPath: "/default/lookup-list-administration",
        component: () => <LookupListAdministrationView />,
        name: i18n.t("views.lookupListAdministration"),
        viewID: UIViewEnum.LookupList_Admin,
        parentViewID: UIViewEnum.LookupListAdmin,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.AdminMiscellaneous,
        allowMobile: true
    },
    {
        layout: "default",
        path: "scheduled-reports-administration",
        fullPath: "/default/scheduled-reports-administration",
        //icon: () => <TrackChanges />,
        component: () => <ScheduledReportsAdminView />,
        name: i18n.t("views.scheduledReports"),
        viewID: UIViewEnum.ReportScheduled_Admin,
        parentViewID: UIViewEnum.ReportScheduleAdmin,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.AdminMiscellaneous,
        allowMobile: true
    },
    {
        layout: "default",
        path: "data-file-import",
        fullPath: "/default/data-file-import",
        //icon: () => <TrackChanges />,
        component: () => <DataFileImportView />,
        name: i18n.t("views.dataFileImport"),
        viewID: UIViewEnum.AdminMiscellaneous_DataFileImport,
        parentViewID: UIViewEnum.DataFileImport,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.AdminMiscellaneous,
        allowMobile: false
    },
    {
        layout: "default",
        path: "memo-auto-text",
        fullPath: "/default/memo-auto-text",
        //icon: () => <TrackChanges />,
        component: () => <MemoAutoTextAdminView />,
        name: i18n.t("views.memoAutoText"),
        viewID: UIViewEnum.AdminMiscellaneous_MemoAutoTextAdmin,
        parentViewID: UIViewEnum.MemoAutoTextAdmin,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.AdminMiscellaneous,
        allowMobile: true
    },
    {
        layout: "default",
        path: "user-permissions-report",
        fullPath: "/default/user-permissions-report",
        //icon: () => <FontAwesomeIcon icon={faBriefcase} size="lg"  />,
        component: UserPermissionsReportView,
        name: i18n.t("views.userPermissionsReport"),
        viewID: UIViewEnum.UserPermissions_Report,
        parentViewID: UIViewEnum.UserPermissionReport,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.UsersAndSecurity,
    },
    {
        layout: "default",
        path: "role-permissions-report",
        fullPath: "/default/role-permissions-report",
        //icon: () => <FontAwesomeIcon icon={faBriefcase} size="lg"  />,
        component: RolePermissionsReportView,
        name: i18n.t("views.rolePermissionsReport"),
        viewID: UIViewEnum.RolePermissions_Report,
        parentViewID: UIViewEnum.RolePermissionReport,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.UsersAndSecurity,
    },
    {
        layout: "default",
        path: "user-list-report",
        fullPath: "/default/user-list-report",
        //icon: () => <FontAwesomeIcon icon={faBriefcase} size="lg"  />,
        component: UserListReportView,
        name: i18n.t("views.userListReport"),
        viewID: UIViewEnum.UserList_Report,
        parentViewID: UIViewEnum.UserListReport,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.UsersAndSecurity,
    },
    {
        layout: "default",
        path: "disabled-recipients-report",
        fullPath: "/default/disabled-recipients-report",
        //icon: () => <FontAwesomeIcon icon={faTableTree} size="lg"  />,
        component: () => <DisabledRecipientsReportView />,
        name: i18n.t("views.disabledRecipientsReport"),
        viewID: UIViewEnum.Disabled_Recipients_Report,
        parentViewID: UIViewEnum.DisabledRecipientsReport,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.UsersAndSecurity,
    },

    {
        layout: "default",
        path: "accounting-invoices",
        fullPath: "/default/accounting-invoices",
        //icon: () => <FontAwesomeIcon icon={faBriefcase} size="lg"  />,
        icon: () => <TrackChanges />,
        component: () => <AccountingInvoiceView />,
        name: i18n.t("views.monthlyInvoice"),
        viewID: UIViewEnum.AccountingAdmin_InvoiceDetails,
        parentViewID: UIViewEnum.AccountingAdmin,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.AdminAccounting,
    },

    {
        layout: "default",
        path: "page-visibility-administration",
        fullPath: "/default/page-visibility-administration",
        component: () =>
            <UICustomizationPresetAdminContextProvider>
                <UICustomizationPresetAdminView />
            </UICustomizationPresetAdminContextProvider>,
        name: i18n.t("views.pageVisibilityAdministration"),
        viewID: UIViewEnum.UsersAndSecurity_PageVisibilityAdmin,
        parentViewID: UIViewEnum.UsersAndSecurity_PageVisibilityAdmin,
        category: UIViewCategory.AdminView,
        allowMobile: false,
        groupingViewID: UIViewEnum.UsersAndSecurity,
    },

        {
        layout: "default",
        path: "configuration-cleanup-view",
        fullPath: "/default/configuration-cleanup-view",
        //icon: () => <TrackChanges />,
        component: () => <ConfigurationCleanupView />,
        name: i18n.t("views.configurationCleanup"),
        viewID: UIViewEnum.AdminMiscellaneous_ConfigurationCleanup,
        parentViewID: UIViewEnum.ConfigurationCleanup,
        category: UIViewCategory.AdminView,
        groupingViewID: UIViewEnum.AdminMiscellaneous,
        allowMobile: false
    },


];

export const routesByViewID = Enumerable
    .from(routes)
    .where(route => Number.isFinite(route.viewID))
    .toDictionary(route => route.viewID);

export const groupRoutes = routes
    .filter(
        r => r.category === UIViewCategory.Group &&
            r.viewID !== undefined &&
            r.parentViewID === undefined
    )
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export const deviceRoutes = routes
    .filter(
        r => r.category === UIViewCategory.Device &&
            r.viewID !== undefined &&
            r.parentViewID === undefined
    )
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export const wellRoutes = routes
    .filter(
        r => r.category === UIViewCategory.Well &&
            r.viewID !== undefined &&
            r.parentViewID === undefined
    )
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export const tankBatteryRoutes = routes
    .filter(
        r => r.category === UIViewCategory.TankBattery &&
            r.viewID !== undefined &&
            r.parentViewID === undefined
    )
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export const tankRoutes = routes
    .filter(
        r => r.category === UIViewCategory.Tank &&
            r.viewID !== undefined &&
            r.parentViewID === undefined
    )
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export const tagRoutes = routes
    .filter(
        r => r.category === UIViewCategory.Tag &&
            r.viewID !== undefined &&
            r.parentViewID === undefined
    )
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
